export default "__VITE_ASSET__DiiuQ1EA__"